import * as React from 'react';
import { Dropdown, Form, Image } from "react-bootstrap";
import './PremiumPayerPersonalDetailsForm.css';

export interface ChangeBankingDetailsFormProps {
    name?: string;
    disableForm?: boolean;
    titleList: string[];
    relationshipList: string[];
    title?: string;
    surname?: string;
    idNumber?: string;
    relationship?: string;
    email?: string;
    phoneNumber?: string;
    notes?: string;
    emitHandleChange;
}

interface State {
    titleDropdownState: boolean;
    name: string;
    title: string;
    surname: string;
    idNumber: string;
    relationship: string;
    email: string;
    phoneNumber: string;
    notes: string;
    relationshipDropdownState: boolean;
}

export class PremiumPayerPersonalDetailsForm extends React.Component<ChangeBankingDetailsFormProps, State> {
    constructor(props: ChangeBankingDetailsFormProps) {
        super(props);

        this.state = {
            titleDropdownState: false,
            relationshipDropdownState: false,
            title: this.props.title ? this.props.title : '',
            name: this.props.name ? this.props.name : '',
            surname: this.props.surname ? this.props.surname : '',
            idNumber: this.props.idNumber ? this.props.idNumber : '',
            relationship: this.props.relationship ? this.props.relationship : '',
            email: this.props.email ? this.props.email : '',
            phoneNumber: this.props.phoneNumber ? this.props.phoneNumber : '',
            notes: this.props.notes ? this.props.notes : '',
        };
        
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.handleTitleDropdownToggle = this.handleTitleDropdownToggle.bind(this);
        this.handleRelationshipToggle = this.handleRelationshipToggle.bind(this);
    }

    async handleChange(e: any) {
        const value: string = e.target.value;
        const key: string = e.target.name;

        await this.setState({ ...this.state, [key]: value });
        this.props.emitHandleChange({
            title: this.state.title,
            name: this.state.name,
            surname: this.state.surname,
            idNumber: this.state.idNumber,
            relationship: this.state.relationship,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            notes: this.state.notes,
            [key]: value,
        });
    }
    
    async handleDropdownChange(e: any, b: any) {
        const value: string = e;
        const key: string = b.target.name;

        await this.setState({ ...this.state, [key]: value });

        this.props.emitHandleChange({
            title: this.state.title,
            name: this.state.name,
            surname: this.state.surname,
            idNumber: this.state.idNumber,
            relationship: this.state.relationship,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            notes: this.state.notes,
            [key]: value,
        });
    }

    async handleTitleDropdownToggle(e: any) {
        this.setState({
            titleDropdownState: e
        });
    }

    async handleRelationshipToggle(e: any) {
        this.setState({
            relationshipDropdownState: e
        });
    }
    
    public render() {
        return (
            <>
                <div className="col-12 col-md-6 change-banking-details__control">
                    <Dropdown id="ChooseItem"
                        onSelect={this.handleDropdownChange}
                        onToggle={this.handleTitleDropdownToggle}>
                        <Dropdown.Toggle id="dropdown-basic" >
                            <>
                                <p className="title mb-1 change-banking-details__label"><b>Title</b></p>
                                <div className="choose-item__selected">
                                    <p className="choose-item__text hide-overflow noma">{this.state.title}</p>
                                    <a className="choose-item__arrow">
                                        { !this.state.titleDropdownState && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-inline-icon.png" /> }
                                        { this.state.titleDropdownState === true && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-up-inline-icon.png" /> }
                                    </a>
                                </div>
                            </>
                        </Dropdown.Toggle>
                        <Dropdown.Menu title="Choose an item" id="nav-dropdown">
                            { this.props.titleList.map((title, idx) => {
                                return <Dropdown.Item name="title" eventKey={title} key={title} value={title}>
                                    {title}
                                    { (idx != this.props.titleList.length - 1) && <hr className="cover-divider" /> }
                                    </Dropdown.Item>
                            }) }
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="col-12 col-md-6 change-banking-details__control">
                    <Form.Group>
                        <Form.Label className="change-banking-details__label font-weight-bold">Name</Form.Label>
                        <Form.Control disabled={this.props.disableForm ?? true} onChange={this.handleChange} value={this.state.name} name="name" type="text" />
                    </Form.Group>
                </div>
                <div className="col-12 col-md-6 change-banking-details__control">
                    <Form.Group>
                        <Form.Label className="change-banking-details__label font-weight-bold">Surname</Form.Label>
                        <Form.Control disabled={this.props.disableForm ?? true} onChange={this.handleChange} value={this.state.surname} name="surname" type="text" />
                    </Form.Group>
                </div>
                <div className="col-12 col-md-6 change-banking-details__control">
                    <Form.Group onChange={this.handleChange}>
                        <Form.Label className="change-banking-details__label font-weight-bold">ID no.</Form.Label>
                        <Form.Control disabled={this.props.disableForm ?? true} value={this.state.idNumber} name="idNumber" type="text" />
                    </Form.Group>
                </div>
                <div className="col-12 col-md-6 change-banking-details__control">
                    <Dropdown id="ChooseItem"
                        onSelect={this.handleDropdownChange}
                        onToggle={this.handleRelationshipToggle}>
                        <Dropdown.Toggle id="dropdown-basic" >
                            <>
                                <p className="title mb-1 change-banking-details__label"><b>Relationship to policyholder</b></p>
                                <div className="choose-item__selected">
                                    <p className="choose-item__text hide-overflow noma">{this.state.relationship}</p>
                                    <a className="choose-item__arrow">
                                        { !this.state.relationshipDropdownState && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-inline-icon.png" /> }
                                        { this.state.relationshipDropdownState === true && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-up-inline-icon.png" /> }
                                    </a>
                                </div>
                            </>
                        </Dropdown.Toggle>
                        <Dropdown.Menu title="Choose an item" id="nav-dropdown">
                            { this.props.relationshipList.map((relationship, idx) => {
                                return <Dropdown.Item name="relationship" eventKey={relationship} key={relationship} value={relationship}>
                                    {relationship}
                                    { (idx != this.props.relationshipList.length - 1) && <hr className="cover-divider" /> }
                                    </Dropdown.Item>
                            }) }
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="col-12 col-md-6 change-banking-details__control">
                    <Form.Group onChange={this.handleChange}>
                        <Form.Label className="change-banking-details__label font-weight-bold">Email</Form.Label>
                        <Form.Control disabled={this.props.disableForm ?? true} value={this.state.email} name="email" type="text" />
                    </Form.Group>
                </div>
                <div className="col-12 col-md-6 change-banking-details__control">
                    <Form.Group onChange={this.handleChange}>
                        <Form.Label className="change-banking-details__label font-weight-bold">Phone no.</Form.Label>
                        <Form.Control disabled={this.props.disableForm ?? true} value={this.state.phoneNumber} name="phoneNumber" type="text" />
                    </Form.Group>
                </div>
                <div className="col-12 change-banking-details__control">
                    <Form.Group onChange={this.handleChange}>
                        <Form.Label className="change-banking-details__label font-weight-bold">Notes about premium payer</Form.Label>
                        <Form.Control as="textarea" disabled={this.props.disableForm ?? true} value={this.state.notes} name="notes" type="text" />
                    </Form.Group>
                </div>
            </>
        )
    }
}
